import * as React from "react";
import Duration, { DateLike } from "app/components/shared/Duration";
import { getDateString } from "app/lib/date";
import UserAvatar from "app/components/shared/UserAvatar";

type DurationFormats = "Short" | "Micro";
export type BuildStates =
  | "passed"
  | "failing"
  | "failed"
  | "blocked"
  | "canceled"
  | "canceling"
  | "creating"
  | "skipped"
  | "not_run"
  | "scheduled"
  | "started";

type Props = {
  durationFormat: DurationFormats;
  build: {
    state: BuildStates;
    cancelReason?: string;
    scheduledAt: DateLike | null | undefined;
    startedAt: DateLike | null | undefined;
    canceledAt: DateLike | null | undefined;
    finishedAt: DateLike | null | undefined;
    cancelledBy?: {
      avatar: string;
      name: string;
    };
  };
};

export default class BuildDuration extends React.PureComponent<Props> {
  static defaultProps = {
    durationFormat: "Short",
  };

  render() {
    const { build } = this.props;

    const DurationFormat = Duration[this.props.durationFormat];

    if (build.state === "passed") {
      return (
        <span>
          {"Passed in "}
          <DurationFormat from={build.startedAt} to={build.finishedAt} />
        </span>
      );
    } else if (build.state === "failing") {
      return (
        <span>
          {"Running for "}
          {/* @ts-expect-error - TS2322 - Type '{ from: DateLike | null | undefined; live: boolean; }' is not assignable to type 'IntrinsicAttributes & PartialProps'. */}
          <DurationFormat from={build.startedAt} live={true} />
          {" and failing"}
        </span>
      );
    } else if (build.state === "failed") {
      return (
        <span>
          {"Failed in "}
          <DurationFormat from={build.startedAt} to={build.finishedAt} />
        </span>
      );
    } else if (build.state === "blocked") {
      if (build.startedAt) {
        return (
          <span>
            {"Passed in "}
            <DurationFormat from={build.startedAt} to={build.finishedAt} />
            {" and blocked"}
          </span>
        );
      }

      return <span>Blocked</span>;
    } else if (build.state === "canceled") {
      const prefixNode =
        build.cancelReason === "build_skipping" ? (
          <span>Canceled automatically</span>
        ) : build.cancelledBy ? (
          <span>
            <UserAvatar
              user={{
                name: build.cancelledBy.name,
                avatar: { url: build.cancelledBy.avatar },
              }}
              style={{ width: 20, height: 20, marginRight: 2 }}
              suppressAltText={true}
            />
            <strong className="semi-bold">{build.cancelledBy.name}</strong>
            {" canceled"}
          </span>
        ) : (
          <span>Canceled</span>
        );

      if (build.startedAt) {
        // @ts-expect-error - TS2345 - Argument of type 'DateLike | null | undefined' is not assignable to parameter of type 'DateLike'.
        const canceledAtString = getDateString(build.canceledAt);
        const title =
          build.cancelReason === "build_skipping"
            ? `This build was automatically canceled by your Build Skipping settings at ${canceledAtString}`
            : build.canceledAt;

        return (
          // @ts-expect-error - TS2322 - Type 'DateLike | null | undefined' is not assignable to type 'string | undefined'.
          <span title={title}>
            {prefixNode}
            {" after "}
            <DurationFormat from={build.startedAt} to={build.canceledAt} />
          </span>
        );
      }

      // @ts-expect-error - TS2322 - Type 'DateLike | null | undefined' is not assignable to type 'string | undefined'.
      return <span title={build.canceledAt}>{prefixNode}</span>;
    } else if (build.state === "creating") {
      return <span>Creating</span>;
    } else if (build.state === "canceling") {
      return <span>Canceling</span>;
    } else if (build.state === "skipped") {
      return <span>Skipped</span>;
    } else if (build.state === "not_run") {
      return <span>Not Run</span>;
    } else if (build.state === "scheduled") {
      return (
        <span>
          {"Waiting for "}
          {/* @ts-expect-error - TS2322 - Type '{ from: DateLike | null | undefined; live: boolean; }' is not assignable to type 'IntrinsicAttributes & PartialProps'. */}
          <DurationFormat from={build.scheduledAt} live={true} />
        </span>
      );
    } else if (build.state === "started") {
      return (
        <span>
          {"Running for "}
          {/* @ts-expect-error - TS2322 - Type '{ from: DateLike | null | undefined; live: boolean; }' is not assignable to type 'IntrinsicAttributes & PartialProps'. */}
          <DurationFormat from={build.startedAt} live={true} />
        </span>
      );
    }

    return null;
  }
}
